// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"9d99dad1","787":"049e95a4"}[chunkId] + ".chunk.js";
};